export default "__VITE_ASSET__fjSVGE_b__"